import React from 'react'
import { ProgresSpinner } from '../common/ProgresSpinner'
import { getRequest } from '../../services/base'

export const SELECT_ALL = 'SELECT_ALL'
export const DESELECT_ALL = 'DESELECT_ALL'

export const handleEnterKey = (evt, callback) => {
  if (evt.key === 'Enter') {
    evt.preventDefault()
    if (callback) {
      callback(evt)
    }
  }
}

export const LoadingLevelsSpinner = () => (
  <div className="mt-5 ml-2 text-white">
    <ProgresSpinner caption={'Loading Levels'} />
  </div>
)

export const downloadAsZip = async (id, file_name, dispatch) => {
  if (dispatch) {
    dispatch({
      type: 'loader',
      data: {
        caption: `Downloading ${file_name}.zip file ...`,
        showLoader: true,
      },
      notification: {},
    })
  }

  let res = await getRequest(`/api/connector_views/zip/${id}/`, true, true)
  if (res?.msg) {
    if (dispatch) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: `${res?.msg}`,
        },
      })
    } else {
      window.confirm(`${res?.msg}`)
    }
  } else {
    /* Start Download Zip file  */
    const downloadZipUrl = window.URL.createObjectURL(new Blob([res]))
    const zipFileLink = document.createElement('a')
    zipFileLink.href = downloadZipUrl
    zipFileLink.setAttribute('download', `${file_name}.zip`)
    document.body.appendChild(zipFileLink)
    zipFileLink.click()
    zipFileLink.remove()
    /* End Download Zip file  */
    if (dispatch) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `File has been successfully downloaded`,
        },
      })
    }
  }
}
